import React, { ComponentType } from 'react';

import getDisplayName from 'common/tools/react/getDisplayName';

/**
 * A Higher-Order Component (HOC) that wraps a component to provide
 * consistent behavior or context within the Allocine ecosystem.
 * * It automatically sets a clear `displayName` for easier debugging
 * within React Developer Tools.
 * @param {ComponentType} ComposedComponent - The React component to be wrapped.
 * @returns {Function} A new component that renders the original one with its props.
 */
const allocineContainer = <T extends Record<string, unknown>>(
  ComposedComponent: ComponentType<T>
) => {
  const RenderedComponent = (props: T) => <ComposedComponent {...props} />;
  RenderedComponent.displayName = `allocineContainer(${getDisplayName(
    ComposedComponent
  )})`;

  return RenderedComponent;
};

export default allocineContainer;
